/**
 * Results Templates
 * Template functions for product filters and search results
 */

window.theme = window.theme || {}
window.theme.tagalys = window.theme.tagalys || {}
window.theme.tagalys.recommendations = window.theme.tagalys.recommendations || {}
window.theme.tagalys.recommendations.templates = window.theme.tagalys.recommendations.templates || {};

(function (templates) {
  templates.miniCartListItem = function (product, index) {
    const featuredImage = product.featured_image?.src || product.featured_image || ''
    const imageWidth = product.featured_image?.width || 2200
    const imageHeight = product.featured_image?.height || 3300
    const productUrl = `/products/${product.handle}`
    const isOnSale = product.compare_at_price && product.compare_at_price > product.price
    const formattedPrice = window.BAO.Utils.formatMoney(product.price * 100)
    const formattedComparePrice = isOnSale ? window.BAO.Utils.formatMoney(product.compare_at_price * 100) : ''
    const firstAvailableVariant = product.variants.find(v => v.available) || product.variants[0]
    const selectId = `mini-cart-sizes-${product.id}`

    const variantOptions = product.variants.map(variant => `
      <option
        value="${variant.id}"
        data-ga-variable-available="${variant.available}"
        data-ga-variable-size="${variant.title}"
        data-ga-variable-product="${product.title}"
        ${variant.id === firstAvailableVariant?.id ? 'selected' : ''}
        ${!variant.available ? 'disabled' : ''}
      >
        ${variant.title}
      </option>
    `).join('')

    return `
      <li
        is="mini-cart-recommendation-card"
        class="mini-cart-recommendations__listItem"
        data-product-id="${product.id}"
        data-ga-el="product-card"
        data-ga-product-handle="${product.handle}"
        data-ga-placement="minicartRecommendations"
        data-ga-index="${index}"
      >
        <img src="${featuredImage}" alt="${product.title}" loading="lazy" class="motion-reduce" width="${imageWidth}" height="${imageHeight}">
        <div class="mini-cart-recommendation-card_content">
          <div>
            <a class="mini-cart-recommendation-card_link" href="${productUrl}" data-ga-el="productCardLink" data-preorder-handle="${product.handle}">
              <h3 class="mini-cart-recommendation-card_title">${product.title}</h3>
            </a>

            <div class="price ${isOnSale ? 'price--on-sale' : ''}">
              <div>
                <div class="price__sale">
                  <div class="price__sale--money">
                    <span class="price-item price-item--regular" data-fp="">
                      <span class="visually-hidden visually-hidden--inline">Regular price:</span>
                      ${isOnSale ? formattedComparePrice : ''}
                    </span>
                    <span class="price-item price-item--sale">
                      <span class="visually-hidden visually-hidden--inline">Sale price:</span>
                      ${formattedPrice}
                    </span>
                    <span class="price-item price-item--label"></span>
                  </div>
                </div>

                <div class="price__regular">
                  <div class="price__regular--money">
                    <span class="price-item price-item--regular" data-fp="">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      ${formattedPrice}
                    </span>
                  </div>
                </div>

                <small class="unit-price caption hidden">
                  <span class="visually-hidden">Unit price</span>
                  <span class="price-item price-item--last">
                    <span></span>
                    <span aria-hidden="true">/</span>
                    <span class="visually-hidden">per</span>
                    <span></span>
                  </span>
                </small>
              </div>
            </div>
          </div>

          <form class="mini-cart-recommendation-card_form">
            <input data-mini-cart-recommendation-el="variantInput" type="hidden" name="id" value="${firstAvailableVariant?.id || ''}">
            <input type="hidden" name="quantity" value="1">

            ${product.variants.length > 1
              ? `
                <label class="util-ScreenReaderOnly" for="${selectId}">Size</label>

                <select data-mini-cart-recommendation-el="select" class="mini-cart-recommendation-card_select" id="${selectId}" aria-label="Size" data-ga-el="miniCartSizeClick">
                  ${variantOptions}
                </select>
              `
              : ''}

            <button class="mini-cart-recommendation-card_submit" type="submit" data-ga-trigger="addToCart" aria-label="Add to cart">
              <div data-mini-cart-recommendation-el="default-state">
                <span class="mini-cart-recommendation-card_submitCopy--mobile">Add</span>
                <span class="mini-cart-recommendation-card_submitCopy--desktop">Add to bag</span>
              </div>
              <div data-mini-cart-recommendation-el="loading-state" class="loading-overlay__spinner hidden">
                <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
              </div>
            </button>
          </form>
        </div>
      </li>
    `
  }
})(window.theme.tagalys.recommendations.templates)
